/**
 * The "fee-set-by-admin" order state, in ONE place.
 *
 * An order placed with a `manual` courier is created at `pending` with a ₱0
 * shipping fee. It must NOT be payable until an admin sets the real fee, and
 * seven separate surfaces need that answer (manual payment submit, the group
 * variant, gateway initiate + webhook, offline payment, the To Pay badge, the
 * admin action list, and two member screens). A shared predicate is what stops
 * them drifting apart — a surface that forgets the check lets a member pay a
 * total that is missing its delivery charge.
 *
 * Two metadata keys, not one:
 *   `manual_shipping`         — permanent provenance; survives settlement so the
 *                               order can still be labelled afterwards.
 *   `manual_shipping_fee_set` — the state the guards read.
 */

export type ManualShippingMetadata = {
  manual_shipping?: unknown;
  manual_shipping_fee_set?: unknown;
};

/** Was this order placed with a fee-set-by-admin courier? */
export function isManualShippingOrder(
  order: { metadata?: ManualShippingMetadata | null } | null | undefined,
): boolean {
  return order?.metadata?.manual_shipping === true;
}

/**
 * Is this order still waiting for an admin to set its shipping fee? While true
 * the buyer cannot pay and the order stays at `pending`.
 */
export function isAwaitingShippingFee(
  order: { metadata?: ManualShippingMetadata | null } | null | undefined,
): boolean {
  return isManualShippingOrder(order) && order?.metadata?.manual_shipping_fee_set !== true;
}
